import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  CreateUser,
  deleteUser,
  UpdateUser,
  activateUser,
  updateLockStatus,
} from "../../api/api";
import { Button } from "../../components/Button/Button";
import Cookies from "js-cookie";
import { useUserList } from "../../data/data";

import Switch from "react-switch";

import { Container, Offcanvas, Modal } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import clsx from "clsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";
import { boolean } from "yup";
export interface IOlympicData {
  symbol: string;
  date: any;
  status: string;
  order: string;
  qty: string;
  price: number;
}
interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}

const UsersList = () => {
  const [email, setEmail] = useState(null);
  const [fname, setFname] = useState(null);
  const [lname, setLname] = useState(null);

  const [extNumber, setExtNumber] = useState(null);
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [response, setResponse] = useState<any>(null);
  const [updateResponse, setUpdateResponse] = useState<any>(null);
  const [show, setShow] = useState(false);
  const [selectUser, setSelectUser] = useState<any>(null);
  const token = Cookies.get("newJwt");
  const { data, isLoading, isFetching, refetch } = useUserList(token);
  const [StateIsActive, setStateIsActive] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [isUserDelete, setIsUserDelete] = useState(false);
  const [isUnlock, setIsUnlock] = useState(false);
  const [isStatus, setIsStatus] = useState(false);
  const [selectedUserDelete, setSelectedUserDelete] = useState<any>(null);
  const [selectedUserStatus, setSelectedUserStatus] = useState<any>(null);
  const [selectedUserUnlock, setSelectedUserUnlock] = useState<any>(null);
  const [showResponse, setShowResponse] = useState(false);
  const [responseStatus, setResponseStatus] = useState<any>();
  const [unlockResponse, setUnlockResponse] = useState(false);
  const [deleteResponse, setDeleteResponse] = useState(false)
  const [statusResponse, setStatusResponse] = useState(false)
  const dataGridRefMain = useRef<AgGridReact<IOlympicData>>(null);
  
  const handleClose = () => {
    setShowModel(false);
  };

  const closeSidebar = () => {
    setShow(false);
    setResponse(null);
    setSelectUser(null);
    setUpdateResponse(null);
    //refetch();
  };
  const showSidebar = () => setShow(true);

  function handEmail(e: any) {
    setEmail(e.target.value);
  }
  function handleFirstName(e: any) {
    setFname(e.target.value);
  }
  function handleLastName(e: any) {
    setLname(e.target.value);
  }
  function handleExtNumber(e: any) {
    setExtNumber(e.target.value);
  }
  // function handlePhoneNumber(e: any) {
  //   //const Pnumber = (...extNumber, e.target.value)
  //   setPhoneNumber(e.target.value);
  // }

  function handlebtnClick() {
    setIsBtnLoading(true);
    CreateUser(email, fname, lname, Cookies.get("newJwt"))
      .then((response) => response?.json())
      .then((response) => {
        setResponse(response);
        setIsBtnLoading(false);
      })
      .catch((err) => {
        refetch();
        setIsBtnLoading(false);
        console.log(err);
      });
  }
  const [inputs, setInputs] = useState<any>({});
  const handlePhoneNumber = (e: any) =>
    setInputs((prevState: any) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

  function handelUpdateUser() {
    setIsBtnLoading(true);
    const id = selectUser?.data?.id;
    const extension = inputs.ext === undefined ? null : inputs.ext;
    const pNumber = inputs.number === undefined ? null : inputs.number;
    const newPhoneNumber = extension + " " + pNumber;
    //const a = newPhoneNumber === null ? null :
    UpdateUser(id, fname, lname, newPhoneNumber, Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setUpdateResponse(response);
        setIsBtnLoading(false);
      })
      .catch((err) => {
        setUpdateResponse("User Edited Successfully");
        refetch();
        console.log(err);
        setIsBtnLoading(false);
      });
  }

  function phoneNumberFormate(p: any) {
    return p.value?.length ? <>{p.value}</> : <>--</>;
  }

  function editUser(data: any) {
    setSelectUser(data);
    setShow(true);
  }

  function userDelete(data: any) {
    setIsUserDelete(true);
    setShowModel(true);
    setSelectedUserDelete(data);
    setIsStatus(false);
    setIsUnlock(false);
  }

  function handleDeleteUser() {
    deleteUser(selectedUserDelete?.data.id, Cookies.get("newJwt"))
      .then((response) => response)
      .then((response) => {
        if (response.status === 204) {
          setShowResponse(true);
          setResponseStatus(response.status);
          setDeleteResponse(true);
          console.log(response);
          setShowModel(false);
          refetch();
        } else {
          setDeleteResponse(false);
        }
      })
      .catch((err) => {
        setShowModel(false);
        refetch();
        console.log(err);
      });
  }

  const handleChange = (params: any) => {
    setShowModel(true);
    setStateIsActive(params.data.isActive);
    setSelectedUserStatus(params.data);
    setIsUserDelete(false);
    setIsStatus(true);
    setIsUnlock(false);
  };

  const handleActionActive = () => {
    const id = selectedUserStatus.id;
    const status = selectedUserStatus.isActive === true ? false : true;

    activateUser(id, status, Cookies.get("newJwt"))
      .then((response) => response)
      .then((response) => {
        if (response.status === 204) {
          setShowResponse(true);
          setResponseStatus(response.status);
          setStatusResponse(true);
          console.log(response);
          refetch();
        } else {
          setStatusResponse(false);
        }
        
      })
      .catch((err) => {
        refetch();
        console.log(err);
      });
    setShowModel(false);
  };

  function handleUnlock(data: any) {
    setShowModel(true);
    setIsUnlock(true);
    setIsUserDelete(false);
    setIsStatus(false);
    setSelectedUserUnlock(data.data);
  }

  const handleChangeUnlock = () => {
    const id = selectedUserUnlock.id;
    updateLockStatus(id, Cookies.get("newJwt"))
      .then((response) => response)
      .then((response) => {
        if (response.status === 204) {
          setShowResponse(true);
          setResponseStatus(response.status);
          setUnlockResponse(true);
          console.log(response);
          refetch();
        } else {
          setUnlockResponse(false);
        }
      })
      .catch((err) => {
        refetch();
        console.log(err);
      });
    console.log(response);
    setShowModel(false);
  };

  //settimeout in useeffect ?
  useEffect(() => {
    if (showResponse === true) {
      setTimeout(() => {
        setShowResponse(false);
      }, 3000);
    }
  }, [showResponse]);
  const [columns, setColumns] = useState([
    {
      headerName: "Email",
      field: "email",
      flex: 1,
      cellClass: "text-start",
      width: 250,
    },
    { headerName: "First Name", field: "firstName", cellClass: "text-start" },
    {
      headerName: "Last Name",
      field: "lastName",
      cellClass: "text-start",
      width: 170,
    },
    {
      headerName: "Phone Number",
      field: "phoneNumber",
      cellClass: "text-start",
      width: 200,
      cellRenderer: phoneNumberFormate,
    },
    {
      headerName: "Status",
      field: "isActive",
      cellClass: "text-start",
      width: 80,
      cellRendererFramework: (params: any) => {
        return (
          <Switch
            checked={params.data.isActive}
            onChange={() => handleChange(params)}
            onColor="#33B271"
            onHandleColor="#fff"
            handleDiameter={30}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={20}
            width={48}
            className="react-switch"
          />
        );
      },
    },
    {
      headerName: "Locked",
      field: "isLocked",
      cellClass: "text-start",
      width: 70,
      cellRendererFramework: (params: any) => {
        return params.data.isLocked === true ? (
          <i
            title="lock"
            onClick={() => handleUnlock({ data: params.data })}
            className="fas fa-fw fa-lock text-danger cursor-pointer"
          ></i>
        ) : (
          <span>--</span>
        );
      },
    },
    {
      headerName: "Actions",
      field: "",
      cellClass: "text-start",
      width: 85,
      cellRendererFramework: (params: any) => {
        return (
          <>
            <span
              onClick={() => editUser({ data: params.data })}
              className="cursor-pointer"
            >
              <i title="edit" className="fas fa-fw fa-edit"></i>
            </span>
            <span
              onClick={() => userDelete({ data: params.data })}
              className="cursor-pointer ml-4"
            >
              <i title="delete" className="fas fa-fw fa-trash"></i>
            </span>
          </>
        );
      },
    },
  ]);

  function handleResetPassword() {
    console.log("resetPassword");
  }
  const handleExportExcel = useCallback(() => {
    const params = {
      processCellCallback: (params: any) => {
        if (params.column.colId === "dateColumn") {
          // Format date as desired
          return params.value
            ? new Date(params.value).toLocaleDateString()
            : "";
        }
        if (typeof params.value === "string") {
          // Apply currency symbol to string values
          return `${params.value}`;
        }
        if (typeof params.value === "number") {
          // Format numbers as currency with the currency symbol
          return `$${params.value.toFixed(2)}`;
        }
        if (params.column.colId.includes("Locked")) {
          // Render true/false as text
          return params.value; // or return "" + params.value;
        }

        if (params.column.colId.includes("Status")) {
          // Render true/false as text
          return params.value; // or return "" + params.value;
        }
       
        if (typeof params.value === "undefined" ) {
          // Format numbers as currency with the currency symbol
          return `--`;
        }
        return params.value !== null ? `$${params.value}` : "--";
      },
    };

    dataGridRefMain.current?.api.exportDataAsExcel(params);
  }, []);

  const handleExportPdf = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape
  
    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;
  
    doc.setFontSize(8);
  
    const title = "Users List";
    const headers = [
      [
        "Email",
        "Last Name",
        "Phone Number",
        "Status",
        "Locked",
      ],
    ];
  
    const transactionData = data.map((e: any) => [
      e.email,
      e.lastName !== null ? `${e.lastName}` : "--",
      e.phoneNumber !== null ? `${e.phoneNumber}` : "--",
      e.isActive !== null ? `${e.isActive}` : "--",
      e.isLocked !== null ? `${e.isLocked}` : "--",
    ]);
  
    let content = {
      startY: 50,
      head: headers,
      body: transactionData,
    };
  
    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("Users.pdf");
  };
  return (
    <div className="w-100">
      <div className="header">
        <h1 className="header-title">Users</h1>
      </div>
      <div className="row w-100 card py-4 px-0">
        {showResponse && showResponse ? (
          <div
            className={clsx(
              "alert alert-dismissible position-absolute statusAlert",

              responseStatus === 204 ? "alert-success" : "alert-warning"
            )}
            style={{ top: "-37px", width: "100%" }}
            role="alert"
          >
            <div className="alert-message">
              {responseStatus === 204 ? (
                <>
                  <strong>User</strong> {unlockResponse === true ? "Unlocked" : null} {deleteResponse === true ?  "Deleted" : null} { statusResponse === true && selectedUserStatus.isActive === true ? "Inactivated" : "Activated"} successfully!{" "}
                </>
              ) : (
                <>
                  Error {unlockResponse === false ? "Unlocked" : null} {deleteResponse === false ?  "Deleted" : null} { statusResponse === false && selectedUserStatus.isActive === false ? "Inactivated" : "Activated"}<strong>User</strong>
                </>
              )}
              
            </div>

            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="alert"
              aria-label="Close"
              onClick={() => setShowResponse(false)}
            ></button>
          </div>
        ) : null}
        <div className="tradeForm position-relative w-100 text-end">
          <div className="">
            <Button
              type="submit"
              className="btn-primary"
              size="btn-xs"
              children="Add"
              //showLoading={isBtnLoading}
              onClick={showSidebar}
            />
              <div className="my-2">
          <i
            className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
            style={{ fontSize: "16px" }}
            onClick={handleExportExcel}
          ></i>
          <i
            className="align-middle far fa-fw fa-file-pdf cursor-pointer"
            onClick={() => handleExportPdf()}
            style={{ fontSize: "16px" }}
          ></i>
        </div>
            <div
              className="ag-theme-alpine"
              style={{
                height: "500px",
                width: "100%",
              }}
            >
              {isFetching ? (
                <div className="w-100 grid_loader">
                  <div className="spinner-border text-dark me-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <AgGridReact
                ref={dataGridRefMain}
                  rowData={data}
                  columnDefs={columns}
                  animateRows={true}
                  domLayout={"normal"}
                  pagination={true}
                  paginationPageSize={20}
                  //paginationAutoPageSize={true}
                ></AgGridReact>
              )}
            </div>

            <Offcanvas
              backdrop="false"
              placement="end"
              show={show}
              onHide={closeSidebar}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Create User</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <div className="my-3">
                  <label htmlFor="email" className="text-body">
                    Email
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => handEmail(e)}
                    //value={selectUser?.data?.email}
                    defaultValue={selectUser?.data?.email}
                  />
                </div>
                <div className="my-3">
                  <label htmlFor="email" className="text-body">
                    First Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => handleFirstName(e)}
                    defaultValue={selectUser?.data?.firstName}
                  />
                </div>
                <div className="my-3">
                  <label htmlFor="email" className="text-body">
                    Last Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => handleLastName(e)}
                    defaultValue={selectUser?.data?.lastName}
                  />
                </div>

                {selectUser !== null ? (
                  <div className="my-3">
                    <label htmlFor="email" className="text-body">
                      Phone Number
                    </label>
                    <div className="d-flex">
                      <select
                        onChange={handlePhoneNumber}
                        className="form-control"
                        style={{ width: "20%", marginRight: 17 }}
                        name="ext"
                        value={inputs.ext || null}
                      >
                        <option>+1</option>
                        <option>+44</option>
                        <option>+43</option>
                      </select>
                      <input
                        type="number"
                        className="form-control w-75"
                        onChange={handlePhoneNumber}
                        defaultValue={selectUser?.data?.phoneNumber}
                        maxLength={10}
                        name="number"
                        value={inputs.number || null}
                      />
                    </div>
                  </div>
                ) : null}

                {response?.id ? (
                  <div className="text-success">User Created Successfully</div>
                ) : (
                  <div className="text-danger">
                    {response?.errors?.[0]?.message}
                  </div>
                )}

                {updateResponse !== null ? (
                  <div className="text-success">{updateResponse}</div>
                ) : (
                  <div className="text-danger">
                    {updateResponse?.errors?.[0]?.message}
                  </div>
                )}

                <div className="text-end mt-3">
                  <Button
                    type="submit"
                    className="btn-primary mx-2"
                    size="btn-xs"
                    children={selectUser !== null ? "Save" : "Create"}
                    showLoading={isBtnLoading}
                    onClick={
                      selectUser !== null ? handelUpdateUser : handlebtnClick
                    }
                  />
                  <Button
                    type="button"
                    className="btn-primary"
                    size="btn-xs"
                    children={"Reset Password"}
                    //showLoading={isBtnLoading}
                    onClick={handleResetPassword}
                  />
                </div>
              </Offcanvas.Body>
            </Offcanvas>
          </div>
        </div>
      </div>
      <Modal
        show={showModel}
        onHide={handleClose}
        centered
        className="modelComponent"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            User
            {isUserDelete === true && isUnlock === false && isStatus === false
              ? " Delete "
              : null}
            {isUserDelete === false && isUnlock === false && isStatus === true
              ? StateIsActive === true
                ? " Inactivate "
                : " Activate "
              : null}
            {isUnlock === true && isUserDelete === false && isStatus === false
              ? " Unlock "
              : null}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you Sure, You want to{" "}
          {isUserDelete === true && isUnlock === false && isStatus === false
            ? "Delete "
            : null}
          {isUserDelete === false && isUnlock === false && isStatus === true
            ? StateIsActive === true
              ? "Inactivate "
              : "Activate "
            : null}
          {isUnlock === true && isUserDelete === false && isStatus === false
            ? "Unlock "
            : null}
          User!
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="submit"
            className="btn-primary"
            size="btn-xs"
            children="Close"
            onClick={handleClose}
          />
          {isUserDelete === true && isUnlock === false && isStatus === false ? (
            <Button
              type="submit"
              className="btn-primary"
              size="btn-xs"
              children="Delete"
              onClick={handleDeleteUser}
            />
          ) : null}
          {isUserDelete === false && isUnlock === false && isStatus === true ? (
            <Button
              type="submit"
              className="btn-primary"
              size="btn-xs"
              children="Ok"
              onClick={handleActionActive}
            />
          ) : null}
          {isUnlock === true && isUserDelete === false && isStatus === false ? (
            <Button
              type="submit"
              className="btn-primary"
              size="btn-xs"
              children="Unlock User"
              onClick={handleChangeUnlock}
            />
          ) : null}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export { UsersList };
